/** Mirrors Singline/Sources/Models/ScoreKind.swift, raw values included. */
export type ScoreKind = 'musicxml' | 'pdf' | 'image';

/** Maps a file extension to a kind; null means the file type is unsupported. */
export function kindFromExtension(extension: string): ScoreKind | null {
  switch (extension.toLowerCase()) {
    case 'musicxml':
    case 'xml':
      return 'musicxml';
    case 'pdf':
      return 'pdf';
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'heic':
    case 'webp':
      return 'image';
    default:
      return null;
  }
}

/**
 * Fallback for files whose name carries no usable extension — the picker
 * still reports a MIME type.
 */
export function kindFromMimeType(mimeType: string | null | undefined): ScoreKind | null {
  if (!mimeType) return null;
  if (mimeType === 'application/pdf') return 'pdf';
  if (mimeType.startsWith('image/')) return 'image';
  if (mimeType.endsWith('xml') || mimeType.includes('musicxml')) return 'musicxml';
  return null;
}

export function kindOfFile(file: { name: string; type: string }): ScoreKind | null {
  const ext = file.name.includes('.') ? file.name.slice(file.name.lastIndexOf('.') + 1) : '';
  return kindFromExtension(ext) ?? kindFromMimeType(file.type);
}
